// src/components/ProdMgrs/components/ProdMgrsQuotaBreakdownHeader.jsx
// =============================================================================
// BLOCK PMGR.QBH.0 — ProdMgrs QuotaBreakdownHeader (NO PCI/GoalPCI, NO ExRep)
// Purpose:
//  - Keep ProdMgrs table column layout consistent with its own row renderer.
//  - Remove PCI and Goal/PCI from display in ProdMgrs.
// =============================================================================

import React from 'react';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

function ProdMgrsQuotaBreakdownHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell variant="head">Category</TableCell>
        <TableCell variant="head" align="right">
          Base
        </TableCell>
        <TableCell variant="head" align="right">
          Total Growth
        </TableCell>

        <TableCell variant="head" align="right">
          Tier 2 Start
        </TableCell>
        <TableCell variant="head" align="right">
          Tier 3 Start
        </TableCell>

        <TableCell variant="head" align="right">
          Rep Multi
        </TableCell>
        <TableCell variant="head" align="right">
          Sample Rate
        </TableCell>

        <TableCell variant="head" align="right">
          Total Samples Allotted
        </TableCell>
        <TableCell variant="head" align="right">
          Total Samples Used
        </TableCell>

        <TableCell variant="head" align="right">
          Yearly Quota
        </TableCell>
        <TableCell variant="head" align="right">
          EOY Bonus
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default React.memo(ProdMgrsQuotaBreakdownHeader);
